import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import InputField from "../../../Components/Masters/InputField";
import { Box, Button, Typography } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../utils/api";
import { validateNumberInput } from "../../../utils/validateFields";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const GeneralDisclosure230 = ({ hide }) => {
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
  const inputData = [
    {
      fieldName: "total",
      title: "Total number of employees",
      type: "number",
      placeholder: "Enter Number",
      width: "25rem",
    },
    {
      fieldName: "numberOfEmployees",
      title: "Number of employees under collective bargaining",
      type: "number",
      placeholder: "Enter Number",
      width: "25rem",
    },
  ];

  const calculate = () => {
    const numberOfEmployees =
      formData?.collectiveBargainingAgreements?.numberOfEmployees || 0;
    const total = formData?.collectiveBargainingAgreements?.total || 0;

    if (total === 0) return 0; // Avoid division by zero
    return ((numberOfEmployees / total) * 100).toFixed(3) || 0; // Round to 2 decimal places
  };

  const { id } = useParams();
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GeneralDisclosures2021`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 =
        res?.data?.data?.GeneralDisclosures2021?.stackHolderEngagement;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      collectiveBargainingAgreements: {
        numberOfEmployees:
          data?.collectiveBargainingAgreements?.numberOfEmployees || "",
        total: data?.collectiveBargainingAgreements?.total || "",
        percentage: data?.collectiveBargainingAgreements?.percentage || "",
      },
      referencedAgreementsTypes: data?.referencedAgreementsTypes || "",
    });
  }, [data]);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name !== "referencedAgreementsTypes" && !validateNumberInput(value))
      return;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
    if (name === "referencedAgreementsTypes") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else {
      const total = formData?.collectiveBargainingAgreements?.total;
      const numberOfEmployees =
        formData?.collectiveBargainingAgreements?.numberOfEmployees;

      if (
        name === "total" &&
        Number(numberOfEmployees || 0) > Number(value || 0)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          numberOfEmployees: "",
        }));
        setFormData((prev) => {
          const updatedData = {
            ...prev,
            collectiveBargainingAgreements: {
              ...prev.collectiveBargainingAgreements,
              [name]: value,
              numberOfEmployees: "",
            },
          };

          return updatedData;
        });
        return;
      }
      if (
        name === "numberOfEmployees" &&
        total &&
        Number(total) < Number(value || 0)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]:
            "Employees under collective bargaining should not be greater than Total Employees.",
        }));
        // setErrors((prevErrors) => ({
        //   ...prevErrors,
        //   [name]:
        //     "",
        // }));
        return;
      }
      setFormData((prev) => {
        const updatedData = {
          ...prev,
          collectiveBargainingAgreements: {
            ...prev.collectiveBargainingAgreements,
            [name]: value,
          },
        };

        return updatedData;
      });
    }
  };

  const validateForm = () => {
    console.log("FormData: ", formData);
    const newErrors = {};
    inputData.forEach((field) => {
      if (formData?.collectiveBargainingAgreements?.[field.fieldName] === "") {
        newErrors[field.fieldName] = "This field is Required";
      }
    });

    if (!formData?.referencedAgreementsTypes?.trim()) {
      newErrors["referencedAgreementsTypes"] = "This field is Required";
    }

    console.log("New Errors: ", newErrors);
    setErrors({ ...errors, ...newErrors });

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      let formData2 = {
        ...formData,
        collectiveBargainingAgreements: {
          ...formData.collectiveBargainingAgreements,
          percentage: calculate(),
        },
      };
      let transformedData2 = {
        stackHolderEngagement: formData2,
        type: "GeneralDisclosures2021",
        submitted2_30: true,
      };
      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/Economic-performance/201-1/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/Economic-performance/201-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <p className={styles.main_heading}>
        2-30 Collective bargaining agreements{" "}
      </p>
      <p className={styles.ques_heading} style={{ marginTop: hide ? "-1.5rem" : "2.5rem" }}>
        a. Disclose the percentage of organization's total workforce that is
        covered by collective bargaining agreements.
      </p>{" "}
      {/* <Box sx={{ display: "flex", gap: 3, ml: 3 }}> */}
      <Box sx={{ display: "flex", gap: 2, ml: 2.5 }}>
        {inputData.map((el) => (
          <Box sx={{ width: el.width }}>
            <Typography
              sx={{ fontWeight: 500, fontSize: "15px", lineHeight: "22px",fontFamily:"inter" }}
            >
              {el.title}
            </Typography>
            <InputField
              placeholder={el.placeholder || "Enter Text"}
              fieldName={el.fieldName}
              value={
                formData?.collectiveBargainingAgreements?.[el.fieldName] || ""
              }
              handleChange={handleChange}
              errors={!!errors[el.fieldName]} // Check if there's an error for this field
              disabled={disabled}
            />

            {errors[el.fieldName] && (
              <p
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  marginTop: "5px",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                }}
              >
                {errors[el.fieldName]}
              </p>
            )}
          </Box>
        ))}
        <Box sx={{ width: "10%" }}>
          <Typography sx={{ fontWeight: 500, fontSize: "15px",fontFamily:"inter" }}>
            Percentage
          </Typography>
          <Typography sx={{ mt: 2, fontSize: "15px" }}>
            {calculate()}%
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", gap: 0.5, mt: "1rem" }}>
        <p
          className={styles.ques_heading}
          style={{ textIndent: "-1.2rem", marginLeft: "0.2rem" }}
        >
          b. Describe whether the working conditions and terms of employment for
          non-union employees reference collective bargaining agreements from
          other organizations in the industry or sector. If so, please specify
          which types of agreements are used as a reference?
        </p>
      </Box>
      <Box sx={{ ml: 2.5 }}>
        <InputField
          placeholder={"Enter Text"}
          fieldName={"referencedAgreementsTypes"}
          mt="0"
          value={formData?.referencedAgreementsTypes || ""}
          handleChange={handleChange}
          errors={!!errors["referencedAgreementsTypes"]} // Check if there's an error for this field
          disabled={disabled}
        />
        {errors["referencedAgreementsTypes"] && (
          <p
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              marginTop: "5px",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["referencedAgreementsTypes"]}
          </p>
        )}
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GeneralDisclosure230;
